
import React, {FC} from 'react';
import {Section} from 'templates/reports/query';

import {Snapshot} from './Snapshot';
import {Static} from './Static';

import * as styles from './styles.module.scss';

type RegionalCompProps = {
	regional: Section
}

export const RegionalComp: FC<RegionalCompProps> = ({regional}) => {
	return (
		<div className={styles.wrapper}>
			<Static />
			<Snapshot data={regional} />
		</div>
	);
};
